// extracted by mini-css-extract-plugin
module.exports = {"container":"BankTitle_container__WAzXt","avatar":"BankTitle_avatar__F4kG_","title":"BankTitle_title__lWR0W"};